import React, { Component } from "react";
import {
  Router,
  RouterProps,
  Styled
} from "../../../toolkit/decorators/Artifact";
import s from "./styles.scss";
import { Container } from "reactstrap";
import FormBuilder from "../../../toolkit/baseForms2/formBuilder/FormBuilder";
import { Inputs, Buttons, formConfig } from "./TotalPassList.form";
import { MemoTable } from "./TotalPassList.table";
import TotalPassDetalle from "../../../types/TotalPassDetalle";
import { deleteEmptyProps } from "../../../toolkit/utils/filter-utils";
import { errorNotification } from "../../../utils/notifications";
import { TotalPassListStore } from "../../containers/totalpassList/TotalPassList.store";
import { TotalPassListDispatcher } from "../../containers/totalpassList/TotalPassList.dispatcher";
import { getReporteTotalPasss } from "../../actions/totalPass";

interface Props
  extends TotalPassListStore,
    TotalPassListDispatcher,
    RouterProps<any> {}

interface State {
  downloading: boolean;
  filters: Inputs & {
    page: number;
    size: number;
  };
}

@Router()
@Styled(s)
export default class TotalPassListComponent extends Component<Props, State> {
  state = {
    downloading: false,
    filters: {
      page: 0,
      size: 100
    } as any
  };

  submit = (values: any) => {
    // Búsqueda de datos en página 1
    this.fetchData({ page: 0 } as any, null, values);
  };

  // Este método se invoca por el formulario de paginación, el botón de búsqueda
  // y al inicializar este componente
  fetchData = async (
    { pageSize: tablePageSize, page: tablePage },
    _?: any,
    formFilters?
  ) => {
    const filters = formFilters || this.state.filters;
    const page = tablePage >= 0 ? tablePage : this.state.filters.page;
    const size = tablePageSize >= 0 ? tablePageSize : this.state.filters.size;
    const pageableFilters = deleteEmptyProps({ ...filters, page, size });

    this.setState({ filters: pageableFilters });

    const preview = await this.props.getTotalPassList(pageableFilters);
    if (!preview.fulfilled) {
      errorNotification(
        preview.gettingTotalPassListError ||
          "Error al obtener los clientes TotalPass"
      );
    }
  };

  onExport = () => {
    this.setState({ downloading: true });
    getReporteTotalPasss(this.state.filters, () =>
      this.setState({ downloading: false })
    );
  };

  onEditClick = idPersona => {
    window.open(`/total-pass-detalle/${idPersona}`, "_blank");
  };

  onViewPersonaClick = idPersona => {
    window.open(`/externo/${idPersona}/detalle`, "_blank");
  };

  render() {
    return (
      <Container className="mb-5">
        <FormBuilder<Inputs, Buttons>
          config={formConfig}
          submit={this.submit}
          processing={this.props.gettingTotalPassList || this.state.downloading}
        />

        <hr className="row" />

        <MemoTable
          page={this.props.totalPassList || ({} as Page<TotalPassDetalle>)}
          loading={this.props.gettingTotalPassList || this.state.downloading}
          onFetchData={this.fetchData}
          onExport={this.onExport}
          onEditClick={this.onEditClick}
          onViewPersonaClick={this.onViewPersonaClick}
        />
      </Container>
    );
  }
}
